export default __webpack_public_path__ + "static/media/like.78334eb8.svg";